module.exports = __webpack_public_path__ + "img/Bear17.2df402f9.jpg";